import * as React from 'react'

import { Box, List, Skeleton } from '@factorialco/deprecated-design-system'

export const HiringTeamSkeleton = () => {
  return (
    <>
      <Box gap="s8">
        <Skeleton height="s24" width="s140" />
        <Skeleton height="s24" width="full" />
        <Skeleton height="s24" width="full" />
        <Skeleton height="s24" width="s240" />
        <Skeleton height="s16" width="s140" />
        <Box paddingTop="s8">
          <Skeleton height="s40" width="s140" />
        </Box>
      </Box>
      <Box paddingTop="s40" gap="s16">
        <List>
          <List.ClickableItem>
            <List.Title>
              <Skeleton width="s140" height="s12" />
            </List.Title>

            <List.ActionItem>
              <Skeleton width="s32" height="s32" />
            </List.ActionItem>
          </List.ClickableItem>
          <List.ClickableItem>
            <List.Title>
              <Skeleton width="s120" height="s12" />
            </List.Title>

            <List.ActionItem>
              <Skeleton width="s32" height="s32" />
            </List.ActionItem>
          </List.ClickableItem>
        </List>
      </Box>
    </>
  )
}
